import { render, staticRenderFns } from "./WsCreateDialog.vue?vue&type=template&id=22ef89dc&"
import script from "./WsCreateDialog.vue?vue&type=script&lang=js&"
export * from "./WsCreateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports